let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1Jok2"), load("7KgfJ"), load("5ko8n"), load("2irg6"), load("iLLJH"), load("ePOyH"), load("ltXeo")]).then(() => parcelRequire('bbZCI'));